'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _UIFlex = require('UIComponents/layout/UIFlex');

var _UIFlex2 = _interopRequireDefault(_UIFlex);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _H = require('UIComponents/elements/headings/H5');

var _H2 = _interopRequireDefault(_H);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlanSelectorTileHeader = function PlanSelectorTileHeader(_ref) {
  var children = _ref.children;
  return _react2.default.createElement(
    _UIFlex2.default,
    { justify: 'between' },
    _react2.default.createElement(
      _H2.default,
      null,
      _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.calculator.edition.title' })
    ),
    children
  );
};

exports.default = PlanSelectorTileHeader;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/calculator/PlanSelectorTileHeader.js
// module id = 593
// module chunks = 3 4